var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSessions = function SvgSessions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#70B2FF",
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.5 10.5H12v-.75h6v.75h1.5v-.75H21V12H9V9.75h1.5zm-1.5 3V21h12v-7.5zm3-5.25h6V7.5h1.5v.75H21a1.5 1.5 0 0 1 1.5 1.5V21a1.5 1.5 0 0 1-1.5 1.5H9A1.5 1.5 0 0 1 7.5 21V9.75A1.5 1.5 0 0 1 9 8.25h1.5V7.5H12z",
    clipRule: "evenodd"
  })));
};
export { SvgSessions as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIiByeD0iNSIgZmlsbD0iIzcwQjJGRiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjUgMTAuNUgxMlY5Ljc1SDE4VjEwLjVIMTkuNVY5Ljc1SDIxVjEySDlWOS43NUgxMC41VjEwLjVaTTkgMTMuNVYyMUgyMVYxMy41SDlaTTEyIDguMjVIMThWNy41SDE5LjVWOC4yNUgyMUMyMS44Mjg0IDguMjUgMjIuNSA4LjkyMTU3IDIyLjUgOS43NVYyMUMyMi41IDIxLjgyODQgMjEuODI4NCAyMi41IDIxIDIyLjVIOUM4LjE3MTU3IDIyLjUgNy41IDIxLjgyODQgNy41IDIxVjkuNzVDNy41IDguOTIxNTcgOC4xNzE1NyA4LjI1IDkgOC4yNUgxMC41VjcuNUgxMlY4LjI1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";